import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import withRouter from 'components/components/common/withRouter';
import axios from 'components/AppRequest';
import ReservationUpdateHelper from '../utils/ReservationUpdateHelper';
import LoadingSpinner from 'components/components/common/LoadingSpinner';
import ReservationUpdateValidation from '../utils/ReservationUpdateValidation';
import CommunicateBox from 'components/components/common/CommunicateBox';
import mergeErrors from 'components/helpers/mergeErrors';
import {
  fetchCustomerAddresses,
  fetchBusStops,
  createWarningNotification,
  createErrorNotification
} from 'components/actions/serviceActions';
import TransHelper from 'components/common/translations/TransHelper';
import AppLink from 'components/common/AppLink';

class DashboardEdit extends Component {

  constructor(props) {
    super(props)
    this.cancel = null;
    this.state = {
      loading: false
    };
  }

  componentDidMount() {
    this.props.fetchCustomerAddresses();
    this.props.fetchBusStops();
  }

  trans = (key, pref = "content.reservationEdit") => {
    return TransHelper.translate(this.props.locale, pref + "." + key);
  }

  transNotify = (type) => {
    return this.trans(type, 'content.notifications.reservationEdit');
  }

  handleClickReservationSubmit = (e) => {
    e.preventDefault();
    const { reservationUpdate } = this.props;
    var helperValidation = new ReservationUpdateValidation(reservationUpdate, this.props.locale);
    if (helperValidation.isValidForm()) {
      this.processSending();
    } else {
      this.props.createErrorNotification({
        title: this.transNotify('errorSubmit'),
        message: helperValidation.getFormErrors()
      })
    }
  }

  processSending = () => {
    const { reservation, reservationUpdate } = this.props;
    var helper = new ReservationUpdateHelper(reservation, reservationUpdate);
    if (helper.isNoMadeAnyChange()) {
      this.props.createWarningNotification({
        title: this.transNotify('warning.title'),
        message: this.transNotify('warning.message')
      });
      return;
    }

    if (helper.haveToPayExtra()) {
      TransHelper.redirect(this.props, 'routes.url.dashboardReservationPayment');
    } else {
      //request and redirect to summary
      var params = helper.requestParams();
      this.setState({ loading: true }, () => {
        axios.post('/pwa/reservation/update', params)
          .then(response => {
            this.setState({ loading: false });
            TransHelper.redirect(this.props, 'routes.url.dashboardReservationPayment');
          })
          .catch(err => {
            this.props.createErrorNotification({
              title: this.transNotify('error'),
              message: mergeErrors(err.response.data.errors)
            })
            this.setState({ loading: false });
            console.log('err', err)
          });
      });
    }
  }

  render() {
    const { addressMode, passengerMode, setPassengerMode, setAddressMode,
      reservation, reservationUpdate } = this.props;

    var helperValidation = new ReservationUpdateValidation(reservationUpdate, this.props.locale);
    var helper = new ReservationUpdateHelper(reservation, reservationUpdate);

    const classButtonEditAddress = classNames({
      'button button--edit': true,
      'button--active': addressMode
    });
    const classButtonEditPassenger = classNames({
      'button button--edit': true,
      'button--active': passengerMode
    });

    return (
      <div className={classNames(
        'grid-layout__item',
        'grid-layout__item--desc',
        'grid-layout__item--content-center'
      )}>
        <div className="grid-layout__content-wrap">
          <div className="grid-layout__content-wrap--shadow">
            <div className="content__desc">
              <ul className="edit-flight">
                <li className="edit-flight__item">
                  <div className="edit-flight__desc">
                    <h4 className="edit-flight__label">
                      <FontAwesomeIcon
                        icon={['fas', 'map-marker-alt']}
                      />
                      {this.trans('address')}
                    </h4>
                    <p className={classNames({
                      'error': !helperValidation.addressValid()
                    })}>{reservationUpdate.address.selectedObject.label}</p>
                  </div>
                </li>

                <li className="edit-flight__item">
                  <div className="edit-flight__desc">
                    <h4 className="edit-flight__label">
                      <FontAwesomeIcon
                        icon={['fas', 'users']}
                      />
                      {this.trans('passengers')}
                    </h4>
                    <div className={classNames(
                      'edit-flight__amount', {
                        'error': !helperValidation.passengersValid()
                      })}>
                      <p>{this.trans('adults')}<span>{reservationUpdate.adults}</span></p>
                      <p>{this.trans('kids')}<span>{reservationUpdate.children}</span></p>
                    </div>
                  </div>
                  <div className="edit-flight__button">
                    <button
                      className={classButtonEditPassenger}
                      onClick={setPassengerMode}
                      title={this.trans('editPassengers')}>
                      <FontAwesomeIcon
                        icon={['fas', 'pencil-alt']}
                        size="lg"
                      />
                    </button>
                  </div>
                </li>
              </ul>
            </div>
          </div>

          <div>
            <div className="content__desc">
              <table className="list-order">
                <tbody>
                  <tr>
                    <td className="list-order__label">{this.trans('oldPrice')}</td>
                    <td className="list-order__price">
                      {parseFloat(reservation.price)}{' '}
                      <span className="currency">
                        {this.trans('currency', 'content.common')}
                      </span>
                    </td>
                  </tr>

                  <tr className="list-order__new-price">
                    <td className="list-order__label">{this.trans('changePrice')}</td>
                    <td className="list-order__price list-order__price--new">
                      {helper.differenceLabel()} <span className="currency">{this.trans('currency', 'content.common')}</span>
                    </td>
                  </tr>

                  <tr>
                    <td className="list-order__label list-order__label--big">{this.trans('newPrice')}</td>
                    <td className="list-order__price list-order__price--big">
                      {reservationUpdate.price ? reservationUpdate.price : '--'}
                      {' '}<span className="currency">{this.trans('currency', 'content.common')}</span>
                    </td>
                  </tr>
                </tbody>
              </table>

              {/* TODO: change message depending for type pay: driver/card */}

              <p className="text-center text-small text-italic mb-45">
                {helper.isOnlinePayment() && (
                  <Fragment>
                    {this.trans('payWithCard')}
                  </Fragment>
                )}

                {!helper.isOnlinePayment() && (
                  <Fragment>
                    {this.trans('payDriver')}
                  </Fragment>
                )}
              </p>

              {this.state.loading
                ?
                <LoadingSpinner className="button button--expand" />
                :
                <button
                  className="button button--expand"
                  onClick={this.handleClickReservationSubmit}
                >
                  {this.trans('changeDetails')}
                </button>
              }

              <p className="text-link--no-change" style={{ marginTop: '15px' }}>
                <AppLink
                  className="link-color"
                  to="routes.url.dashboard"
                >
                  {this.trans('changeNothing')}
                </AppLink>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    reservation: state.service.editedReservation,
    reservationUpdate: state.service.paramsForReservationUpdate,
    locale: state.app.locale
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    {
      fetchBusStops, fetchCustomerAddresses,
      createWarningNotification, createErrorNotification
    }
  )(DashboardEdit)
);
